import React from "react";
import './TextAreaField.css'

const TextAreaField =
    (
        {
            setAttribute,
            style,
            type,
            value,
            checked,
            disabled,
            readOnly,
            onBlur
        }
    ) => {

        const handleSelectChange = (lookupChanged, id) => {
            lookupChanged(id)
        }

        return (
            <textarea
                className='textarea-field'
                onChange={(e) => { handleSelectChange(setAttribute, e.target.value) }}
                type={type}
                value={value}
                checked={checked}
                disabled={disabled}
                readOnly={readOnly}
                style={style}
                onBlur={onBlur}
            />
        );
    }

export default TextAreaField;
